import { ChartType } from '@/index';
import { getRegisteredChartTypes } from './chart-builder-registry.js';
import { SupportedChartType } from './types.js';
import {
  ChartDataOptions,
  CartesianChartDataOptions,
  StyledMeasureColumn,
} from '@/chart-data-options/types';
import { isCartesian } from '@/chart-options-processor/translations/types';

/**
 * Helper function to detect if chart data options contain forecast or trend analytics
 */
export function hasForecastOrTrend(dataOptions: ChartDataOptions, chartType: ChartType): boolean {
  if (!isCartesian(chartType)) return false;
  const cartesianDataOptions = dataOptions as CartesianChartDataOptions;
  return cartesianDataOptions.value.some(
    (v) =>
      (v as StyledMeasureColumn)?.forecast !== undefined ||
      (v as StyledMeasureColumn)?.trend !== undefined,
  );
}

export function isRestructuredChartType(chartType: ChartType): chartType is SupportedChartType {
  const restructuredChartTypes = getRegisteredChartTypes();
  return restructuredChartTypes.includes(chartType as SupportedChartType);
}
